import { Box, Link, Typography } from '@mui/material';

export const HackerRankDescription = () => {
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="body2" color="text.secondary" ml={2}>
        Coding challenge will take place on the HackerRank platform <br /> right
        in your browser.{' '}
        <Link
          href="https://candidatesupport.hackerrank.com/collections/7250008484-test-1"
          target="_blank"
          color="text.brand"
        >
          See what to expect
        </Link>
        .
      </Typography>
    </Box>
  );
};
